import { createInstance, OptimizelyProvider, useDecision } from '@optimizely/react-sdk';
import React__default, { useState, useEffect } from 'react';
import { useCheckoutContext } from '@zooplus/checkout-state';
import ENV from '../../env/environment.js';
import useAdobeUtils from '../../hooks/useAdobe.js';
import { getHash, sameArticles } from '../../utils/utils.js';
import FallbackComponent from '../ErrorFallback.js';
import SentryErrorBoundary from '../SentryErrorBoundary.js';
import { CartBox } from './CartBox.js';
import { Skeleton } from '@zooplus/ui-components';
import '../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { SiteProvider } from '../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import { findSiteByDomain } from '../../node_modules/@zooplus/commons-lang/dist/es/services/langService.js';
import '../../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';

const optimizely = createInstance({
    sdkKey: ENV.OPTIMIZELY_KEY,
});
const AutoshipmentCartBox = (props) => {
    const { checkoutSubscriptionState } = useCheckoutContext('autoshipment-component');
    const { trackDefaultInterval } = useAdobeUtils();
    const [decisionForceInterval, clientReady] = useDecision('toggle_force_interval');
    const [selectedArticles, setSelectedArticles] = useState(undefined);
    const [guestAccount, setGuestAccount] = useState(false);
    const [intervalSelected, setIntervalSelected] = useState(undefined);
    const [anyEligibleArticle, setAnyEligibleArticle] = useState(false);
    const [anySwitchDisplayed, setAnySwitchDisplayed] = useState(false);
    const [sessionId, setSessionId] = useState(checkoutSubscriptionState?.sid);
    useEffect(() => {
        if (sessionId && sessionId != checkoutSubscriptionState?.sid)
            setSessionId(checkoutSubscriptionState?.sid);
    }, [checkoutSubscriptionState?.sid]);
    useEffect(() => {
        if (checkoutSubscriptionState?.articles) {
            const subscriptionAppliedArticles = checkoutSubscriptionState?.articles?.filter((article) => article.subscriptionApplied || article.type === 'SavingsPlan');
            if (subscriptionAppliedArticles &&
                subscriptionAppliedArticles.some((article) => article.subscriptionApplied)) {
                const articlesSelected = subscriptionAppliedArticles.map((article) => {
                    return {
                        articleShopId: article.id,
                        quantity: article.quantity,
                    };
                });
                if (!sameArticles(articlesSelected, selectedArticles || []))
                    setSelectedArticles(articlesSelected);
            }
            else
                setSelectedArticles(undefined);
            setAnyEligibleArticle(checkoutSubscriptionState?.articles?.some((article) => article.subscriptionDetails?.eligible === true) || false);
            setAnySwitchDisplayed(checkoutSubscriptionState?.articles?.some((article) => article.subscriptionDetails?.displaySwitch === true) || false);
        }
        else {
            setSelectedArticles(undefined);
            setAnyEligibleArticle(false);
            setAnySwitchDisplayed(false);
        }
    }, [checkoutSubscriptionState?.articles]);
    useEffect(() => {
        checkoutSubscriptionState?.customerType
            ? setGuestAccount(checkoutSubscriptionState.customerType === 'GC')
            : setGuestAccount(false);
    }, [checkoutSubscriptionState?.customerType]);
    useEffect(() => {
        if (checkoutSubscriptionState?.subscriptionInterval)
            setIntervalSelected(checkoutSubscriptionState.subscriptionInterval / 7);
        else if (!intervalSelected) {
            if (decisionForceInterval.enabled && clientReady) {
                trackDefaultInterval(sessionId, 'no_interval_bucket');
            }
            else {
                setIntervalSelected(4);
                trackDefaultInterval(sessionId, '4_weeks_bucket');
            }
        }
    }, [checkoutSubscriptionState?.subscriptionInterval]);
    return (React__default.createElement(CartBox, { keycloakToken: props.keycloakToken, stickySection: props.stickySection, intervalSelected: intervalSelected, checkIntervalSelected: props.checkIntervalSelected && decisionForceInterval.enabled && clientReady, removeAutoshipment: checkoutSubscriptionState.removeSubscription, sendNewInterval: checkoutSubscriptionState.setSubscriptionInterval, setIsSubscriptionValid: checkoutSubscriptionState.setIsSubscriptionValid, articles: selectedArticles, deliveryCountry: checkoutSubscriptionState?.selectedDeliveryCountryIsoCode, deliveryRegion: checkoutSubscriptionState?.selectedDeliveryCountry, deliveryZipCode: checkoutSubscriptionState?.zipCode, guestAccount: guestAccount, paymentError: !checkoutSubscriptionState.validSubscription, anyEligibleArticle: anyEligibleArticle, anySwitchDisplayed: anySwitchDisplayed }));
};
const AutoshipmentCartBoxWrapper = (props) => {
    const { checkoutSubscriptionState, appConfig } = useCheckoutContext('autoshipment-component');
    const [optimizelyId, setOptimizelyId] = useState();
    const [sessionId, setSessionId] = useState(checkoutSubscriptionState?.sid);
    const siteDomain = appConfig?.shop.domain;
    const locale = appConfig?.locale;
    useEffect(() => {
        if (sessionId && sessionId != checkoutSubscriptionState?.sid)
            setSessionId(checkoutSubscriptionState?.sid);
    }, [checkoutSubscriptionState?.sid]);
    useEffect(() => {
        if (sessionId) {
            getHash(sessionId).then((hash) => {
                setOptimizelyId(hash);
            });
        }
    }, [sessionId]);
    const site = findSiteByDomain(siteDomain);
    return (React__default.createElement(SentryErrorBoundary, { FallbackComponent: FallbackComponent },
        React__default.createElement(SiteProvider, { site: site, locale: locale }, optimizelyId ? (React__default.createElement(OptimizelyProvider, { optimizely: optimizely, user: {
                id: optimizelyId,
                attributes: {
                    user_id: optimizelyId,
                    country: site.country,
                    brand: site.realm,
                    site_domain: site.domain,
                },
            } },
            React__default.createElement(AutoshipmentCartBox, { keycloakToken: props.keycloakToken, stickySection: props.stickySection, checkIntervalSelected: true }))) : (React__default.createElement(Skeleton, null)))));
};

export { AutoshipmentCartBox, AutoshipmentCartBoxWrapper };
//# sourceMappingURL=AutoshipmentCartBox.js.map
